module.exports = __webpack_public_path__ + "img/official.90b4dfe4.png";